import { useMemo } from 'react';
import useI18n from '../../i18n/hooks/useI18n';
import { PriceComponent } from '../../../typings/transaction';

const useFormattedPrice: (price?: PriceComponent['value'], allowZeroValue?: boolean) => string =
  function useFormattedPrice(price, allowZeroValue) {
    const i18n = useI18n();
    const currency =
      price?.currency && i18n(`dlv_generics_currency_${price.currency.toLowerCase()}`);

    const convertToFormattedString = (amount: number): string => {
      if (!amount && !allowZeroValue) {
        return null;
      }

      return `${(amount / 100)
        .toFixed(2)
        .toString()
        .replace('.', i18n('dlv_generics_decimal_separator'))}${String.fromCharCode(
        160,
      )}${currency}`;
    };

    return useMemo(() => convertToFormattedString(price?.amount), [price, currency]);
  };

export default useFormattedPrice;
